// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world
//  <script id='pixel-script-poptin' src='https://cdn.popt.in/pixel.js?id=cef57f397881f' async='true'></script> 

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});
 
